import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import './preloader.css';

const PreLoader = ({ setLoading }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [setLoading]);

  const preloaderVariants = {
    initial: {
      y: "0"
    },
    exit: {
      y: "-100%",  // Changed from "100%" to "-100%" for upward slide
      transition: {
        duration: 0.8,
        ease: "easeInOut"
      }
    }
  };

  const textVariants = {
    hidden: {
      y: 50,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.4,
        delayChildren: 0.3
      }
    }
  };

  return (
    <motion.div 
      className="preloader"
      variants={preloaderVariants}
      initial="initial"
      exit="exit"
    >
      <motion.div 
        className="texts-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.span variants={textVariants}>Learning, </motion.span>
        <motion.span variants={textVariants}>Solving,</motion.span>
        <motion.span variants={textVariants}>Coding.</motion.span>
      </motion.div>
    </motion.div>
  );
};

export default PreLoader;
